import { dinero, toDecimal, toSnapshot, AUD } from 'dinero.js';

/**
 * Create a Dinero v2 object from an amount in minor units (cents).
 */
export function fromCents(amount) {
    return dinero({ amount: Number.parseInt(amount) || 0, currency: AUD });
}

/**
 * Format a cents amount as a currency string, e.g. "$1,234.56".
 */
export function formatCurrency(amount) {
    const d = fromCents(amount);
    return toDecimal(d, ({ value }) => {
        const num = Number.parseFloat(value);
        const formatted = num.toLocaleString('en-AU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return `$${formatted}`;
    });
}

/**
 * Format a cents amount as a plain decimal string, e.g. "1234.56".
 * Useful for analytics values where no currency symbol is needed.
 */
export function formatDecimal(amount) {
    const d = fromCents(amount);
    return toDecimal(d, ({ value }) => {
        const num = Number.parseFloat(value);
        return num.toFixed(2);
    });
}

/**
 * Get the raw amount in minor units (cents) from a cents value.
 * Equivalent to the old Dinero({ amount }).getAmount().
 */
export function getAmount(amount) {
    const d = fromCents(amount);
    return toSnapshot(d).amount;
}
